import { readable, writable, derived } from "svelte/store";

// import iconInflation from "./icons/icon_inflation.svg";

// ///////////////////////////////////////////////////////////
// Frontend config
// ///////////////////////////////////////////////////////////

// export const headline = readable("Live-Grafiken");


export const headerBlack = writable(false);
export const headerToc = writable("");
export const headerState = writable("initial");

// export const monitorsBase = writable([
// 	{
// 		id: "inflation",
// 		component: InflationMonitor,
// 		size: 204,
// 		headlineText: "Inflationsrate",
// 		link: {
// 			text: "Inflations-Monitor",
// 			url:
// 				"https://interaktiv.tagesspiegel.de/lab/inflation-monitor-wie-stark-steigen-die-preise/" +
// 				parameters,
// 			icon: iconInflation,
// 			iconWidth: 21,
// 		},
// 	},
// 	{
// 		id: "ukraine",
// 		component: UkraineMonitor,
// 		size: 218,
// 		headlineText: "Ukraine-Krieg",
// 		link: {
// 			text: "Live-Karte",
// 			url:
// 				"https://interaktiv.tagesspiegel.de/lab/wie-weit-sind-die-soldaten-aktuelle-karte-der-russischen-invasion-in-der-ukraine/" +
// 				parameters,
// 			icon: iconUkraine,
// 			iconWidth: 38,
// 		},
// 	},
// 	{
// 		id: "covid",
// 		component: CovidMonitor,
// 		size: 203,
// 		headlineText: "Corona-Inzidenz",
// 		link: {
// 			text: "Corona-Dashboard",
// 			url:
// 				"https://interaktiv.tagesspiegel.de/lab/karte-sars-cov-2-in-deutschland-landkreise/" +
// 				parameters,
// 			icon: iconCovid,
// 			iconWidth: 20,
// 		},
// 	},
// 	{
// 		id: "climate",
// 		component: ClimateMonitor,
// 		size: 235,
// 		headlineText: "Erderwärmung",
// 		link: {
// 			text: "Temperatur-Monitor",
// 			url:
// 				"https://interaktiv.tagesspiegel.de/lab/temperaturmonitor-wetter-vs-klima-sind-die-temperaturen-in-deutschland-gerade-normal/" +
// 				parameters,
// 			icon: iconClimate,
// 			iconWidth: 16,
// 		},
// 	},
// ]);

// export const monitors = derived([monitorsBase, config], ([monitorsBase, config]) =>
// 	monitorsBase.map((m) => {
// 		return {
// 			...m,
// 			shown: config.includes(m.id),
// 		};
// 	})
// );

// export const monitorsById = derived(monitors, (monitors) =>
// 	monitors.reduce((obj, item) => ({ ...obj, [item.id]: item }), {})
// );
